import { Card } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm } from 'redux-form';
import Button from '../../components/elements/Button';
// import TextArea from '../../components/fields/TextArea';
import parse from 'html-react-parser';
import dompurify from 'dompurify';
import { dataPositions, validate } from './constants';
import styles from './styles.scoped.css';

export function Component({
  fromSubPangkalan = false,
  item = {},
  onCloseModal = () => {},
}) {
  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        {!fromSubPangkalan && (
          <div className={styles['form-control']}>
            <label>Posisi FAQ</label>
            <span>
              {dataPositions.find((data) => data.value === item.position).label}
            </span>
          </div>
        )}
        <div className={styles['form-control']}>
          <label>Kategori</label>
          <span>{item.category}</span>
        </div>
        <div className={styles['form-control']}>
          <label>Judul Pertanyaan</label>
          <span>{item.question}</span>
        </div>
        {/* <Field component={TextArea} inputProps={answer} name="answer" /> */}
        <div className={styles['input-group']}>
          <label>Deskripsi</label>
          <div>{parse(dompurify.sanitize(item.answer))}</div>
        </div>
        <div className={styles['form-action']}>
          <Button onClick={onCloseModal} outlined={true}>
            Kembali
          </Button>
        </div>
      </Card>
    </div>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  fromSubPangkalan: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  item: PropTypes.object,
  onCloseModal: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  type: PropTypes.string,
};

export default reduxForm({
  form: 'faq',
  initialValues: {
    question: '',
    answer: '',
    category: '',
    position: '',
  },
  validate,
})(Component);
